RivalIQ.apps.Insights.module('curations.filters', function (filters, App, Backbone, Marionette, $, _) {

    'use strict';

    filters._linkedinProcessMetadata = function (curation, metadata) {
        const path = '/insights/linkedin';

        // TODO hacky
        const presences = _.map(metadata.companies, function (company) {
            return _.extend({}, company, {
                accountPresenceId: company.joinId,
                companyId: company.id,
                linked_in_presence_id: company.presenceId,
                isLoading: !_.get(company, ['sources', RivalIQ.enums.sources.LINKEDIN, 'fetched'], true)
            });
        });

        const accountPresences = _.map(metadata.linkedInPresences, function (company) {
            return _.extend({}, company, {
                accountPresenceId: company.joinId,
                companyId: company.id,
                linked_in_presence_id: company.presenceId
            });
        });

        const validPresences = _.filter(presences, function (presence) {
            return _.get(presence.sources, [RivalIQ.enums.sources.LINKEDIN, 'validToken']);
        });

        // all presences both mapped and unassociated w valid tokens
        const allAccountPresences = _.union(accountPresences, metadata.unassociatedPresences);

        curation.sources = metadata.sources;
        curation.presences = new App.collections.LinkedInPresences(validPresences);
        curation.accountPresences = new App.collections.LinkedInPresences(allAccountPresences);
        curation.accountCompanies = metadata.accountCompanies;
        curation.unassociatedPresences = new App.collections.LinkedInPresences(metadata.unassociatedPresences);

        if (curation.presences.length) {
            curation.presence = curation.presences.find(function (presence) {
                // select the presence matching `presenceId` if we have a valid token for it.
                return presence.get('accountPresenceId') === curation.getProp('accountPresenceId') &&
                    _.get(presence.get('sources'), [RivalIQ.enums.sources.LINKEDIN, 'validToken']);
            });

            if (!curation.presence) {

                // no selected presence; let's try to default to the last one the user had selected.
                const companyId = _.get(RivalIQ.state.user.get('lastSelectedLinkedinCompanies'), curation.getProp('landscapeId'));
                if (companyId) {
                    const presence = curation.presences.findWhere({
                        companyId: companyId
                    });
                    if (presence) {
                        return `${path}/${presence.get('accountPresenceId')}`;
                    }
                }

                // find the first presence that has a valid token
                const pick = curation.presences.find(function (presence) {
                    return _.get(presence.get('sources'), [RivalIQ.enums.sources.LINKEDIN, 'validToken']);
                });

                if (pick) {
                    return `${path}/${pick.get('accountPresenceId')}`;
                }
            }
        }

        if (curation.presence) {
            curation.setProps(
                {
                    companyId: curation.presence.get('companyId'),
                    insightsBlocked: curation.presence.get('isLoading')
                },
                {
                    silent: true,
                    navigate: false
                }
            );
        }

        if (!curation.presence && curation.getProp('accountPresenceId')) {
            return path;
        }
    };

    // Load insights presences and redirect to a configured presence if one
    // exists
    filters.liPresenceLoader = function (curation) {
        const props = curation.getProps();
        return RivalIQ.data.privateMetadata.fetch(props, {
            force: true
        }).then(function (metadata) {
            return filters._linkedinProcessMetadata(curation, metadata);
        });
    };

    filters._facebookProcessMetadata = function (curation, metadata) {
        const path = 'insights/facebook';

        const presences = _(metadata.companies)
            .filter(function (company) {
                return _.get(company, ['sources', RivalIQ.enums.sources.FACEBOOK_INSIGHTS, 'validToken']);
            })
            .map(function (company) {
                return _.extend({}, company, {
                    id: company.presenceId,
                    companyId: company.id,
                    isLoading: !_.get(company, ['sources', RivalIQ.enums.sources.FACEBOOK_INSIGHTS, 'fetched'], true)
                });
            })
            .value();

        curation.sources = metadata.sources;
        curation.presences = new Backbone.Collection(presences);
        curation.unassociatedPresences = new Backbone.Collection();

        if (curation.presences.length) {
            curation.presence = curation.presences.find(function (presence) {
                // select the presence matching `presenceId` if we have a valid token for it.
                return presence.get('companyId') === curation.getProp('companyId') &&
                    _.get(presence.get('sources'), [RivalIQ.enums.sources.FACEBOOK_INSIGHTS, 'validToken']);
            });

            if (!curation.presence) {

                // no selected presence; let's try to default to the last one the user had selected.
                const companyId = _.get(RivalIQ.state.user.get('lastSelectedFacebookCompanies'), curation.getProp('landscapeId'));
                if (companyId) {
                    const presence = curation.presences.findWhere({
                        companyId: companyId
                    });

                    if (presence && _.get(presence.get('sources'), [RivalIQ.enums.sources.FACEBOOK_INSIGHTS, 'validToken'])) {
                        return `${path}/${presence.get('companyId')}`;
                    }
                }

                const pick = curation.presences.find(function (presence) {
                    return _.get(presence.get('sources'), [RivalIQ.enums.sources.FACEBOOK_INSIGHTS, 'validToken']);
                });

                if (pick) {
                    return `${path}/${pick.get('companyId')}`;
                }
            }

            // TODO necessary?
            if (curation.presence) {
                curation.setProps({
                    presenceId: curation.presence.get('id'),
                    insightsBlocked: curation.presence.get('isLoading')
                }, {
                    silent: true,
                    navigate: false
                });
            }
        }


        if (!curation.presence && curation.getProp('companyId')) {
            return path;
        }
    };

    filters.fbPresenceLoader = function (curation) {
        const props = curation.getProps();
        return RivalIQ.data.privateMetadata.fetch(props, {
            force: true
        }).then(function (metadata) {
            return filters._facebookProcessMetadata(curation, metadata);
        });
    };

    filters.twitterPresenceLoader = function (curation) {
        const props = curation.getProps();
        return RivalIQ.data.privateMetadata.fetch(props, {
            force: true
        }).then(function (metadata) {
            return filters._twitterProcessMetadata(curation, metadata);
        });
    };

    // TODO: should we be using INSIGHTS_PATH_MAP?
    const TWITTER_INSIGHTS_PATH_MAP = {};
    filters._twitterProcessMetadata = function (curation, metadata) {
        const path = 'insights/twitter';
        const presences = _(metadata.companies)
            .filter(function (company) {
                const validToken = _.get(company, ['sources', RivalIQ.enums.sources.TWITTER_INSIGHTS, 'validToken'], false);
                const protectedPresence = _.get(company, ['sources', RivalIQ.enums.sources.TWITTER_INSIGHTS, 'protected'], false);
                return (validToken && !protectedPresence);
            })
            .map(function (company) {
                return _.extend({}, company, {
                    id: company.presenceId,
                    companyId: company.id,
                    screen_name: _.get(company, ['sources', RivalIQ.enums.sources.TWITTER_INSIGHTS, 'handle']),
                    isLoading: !_.get(company, ['sources', RivalIQ.enums.sources.TWITTER_INSIGHTS, 'fetched'], true)
                });
            })
            .value();

        const expiredPresences = _(metadata.expiredPresences)
            .map(function (presence) {
                return _.extend({}, presence, {
                    screen_name: _.get(presence, ['presence', 'handle'])
                });
            })
            .value();

        // all valid twitter presences across the app
        const accountPresences = _.map(metadata.allPresences, function (company) {
            return _.extend({}, company, {
                id: company.joinId,
                companyId: company.id,
                twitter_presence_id: company.presence.id,
                post_history_since: company.presence.post_history_since
            });
        });

        curation.accountPresences = new Backbone.Collection(accountPresences);
        curation.sources = metadata.sources;
        curation.protected = metadata.protected;
        curation.presences = new Backbone.Collection(presences);
        curation.expiredPresences = new Backbone.Collection(expiredPresences);
        curation.unassociatedPresences = new Backbone.Collection(metadata.unassociatedPresences);
        curation.unmappedAccountPresences = new Backbone.Collection(metadata.unmappedPresences);
        curation.totalTokensInAccount = _.get(metadata, ['sources', RivalIQ.enums.sources.TWITTER_INSIGHTS, 'totalTokensInAccount']);

        const isNewToken = curation.queryProps.newToken;
        if (isNewToken) {
            // grab the newest token added and load that presence
            const newestPresenceId = metadata.newestPresenceId;
            curation.presence = curation.presences.find(function (presence) {
                return presence.get('presenceId') === newestPresenceId;
            });
            curation.setProps({
                newToken: null
            });
        }

        if (!curation.presence && curation.presences.length) {

            curation.presence = curation.presences.find(function (presence) {
                // select the presence matching `presenceId` if we have a valid token for it.
                return presence.get('companyId') === curation.getProp('companyId') &&
                    _.get(presence.get('sources'), [RivalIQ.enums.sources.TWITTER_INSIGHTS, 'validToken']);
            });

            if (!curation.presence) {

                // no selected presence; let's try to default to the last one the user had selected.
                const lastSelectedCompanyId = _.get(RivalIQ.state.user.get('lastSelectedTwitterCompanies'), curation.getProp('landscapeId'));
                if (lastSelectedCompanyId) {
                    const presence = curation.presences.findWhere({
                        companyId: lastSelectedCompanyId
                    });

                    if (presence && _.get(presence.get('sources'), [RivalIQ.enums.sources.TWITTER_INSIGHTS, 'validToken'])) {
                        return `${path}/${presence.get('companyId')}`;
                    }
                }

                const pick = curation.presences.find(function (presence) {
                    return _.get(presence.get('sources'), [RivalIQ.enums.sources.TWITTER_INSIGHTS, 'validToken']);
                });

                if (pick) {
                    return _.compact([
                        path,
                        pick.get('companyId'),
                        _.get(TWITTER_INSIGHTS_PATH_MAP, [curation.id])
                    ]).join('/');
                }
            }
        }

        if (curation.presence) {
            const companyId = curation.getProp('companyId');
            // NOTE if we have a new token and do not have a company id set
            // then we need to navigate so that the base page URL gets the
            // `companyId` prop specifically (see #23155)
            curation.setProps({
                presenceId: curation.presence.get('id'),
                companyId: curation.presence.get('companyId'),
                insightsBlocked: curation.presence.get('isLoading')
            }, {
                silent: true,
                navigate: (isNewToken && !companyId)
            });
        }

        if (!curation.presence && curation.getProp('companyId')) {
            return path;
        }
    };

    function isWithoutInsights(curation) {
        // if accountPresences is populated, insights is valid iff there is at least one presence in the account.
        const validLinkedInPresences = (curation.accountPresences ? !curation.accountPresences.isEmpty() : true);
        return (!curation.presence && validLinkedInPresences && curation.unassociatedPresences.isEmpty());
    }

    filters.expiredPresence = function (viewParams) {
        return function (curation) {
            // no valid companies; at least one company mapped to expired token
            if (!curation.expiredPresences.isEmpty() && curation.presences.isEmpty()) {

                const handles = _.map(curation.expiredPresences.toJSON(), function (presence) {
                    return `@${presence.screen_name}`;
                });
                if (handles.length) {
                    const ExpiredPresenceView = Marionette.LayoutView.extend(viewParams);
                    return new ExpiredPresenceView({
                        curation: curation,
                        handles: handles.join(', ')
                    });
                }
            }
        };
    };

    filters.noInsightsInLandscape = function (viewParams) {
        return function (curation) {
            if (curation.accountPresences) {
                const mappedPresences = _.filter(curation.accountPresences.toJSON(), function (presence) {
                    return !_.isNull(presence.companyId);
                }).length > 0;

                // no current landscape LI presence but account has at least one mapped presence
                if (!curation.presence && !curation.accountPresences.isEmpty() && mappedPresences) {
                    const NoInsightsInLandscape = Marionette.LayoutView.extend(viewParams);
                    return new NoInsightsInLandscape({
                        curation: curation
                    });
                }
            }
        };
    };

    filters.noInsightsInAccount = function (viewParams) {
        return function (curation) {
            if (!curation.unmappedAccountPresences.isEmpty() && curation.presences.isEmpty()) {
                const handles = _.map(curation.unmappedAccountPresences.toJSON(), function (presence) {
                    return `@${_.get(presence, ['sources', RivalIQ.enums.sources.TWITTER_INSIGHTS, 'handle'])}`;
                });

                if (handles.length) {
                    const NoInsightsInLandscape = Marionette.LayoutView.extend(viewParams);
                    return new NoInsightsInLandscape({
                        curation: curation,
                        handle: handles.join(', ')
                    });
                }
            }
        };
    };

    filters.protectedAccount = function (viewParams) {
        return function (curation) {
            // show protected view if only presence in landscape is protected
            if (curation.presences.isEmpty() && curation.protected && curation.protected.length) {
                const handles = _.map(curation.protected, function (presence) {
                    return `@${_.get(presence, ['sources', RivalIQ.enums.sources.TWITTER_INSIGHTS, 'handle'])}`;
                });
                if (handles.length) {
                    const ProtectedAccountView = Marionette.LayoutView.extend(viewParams);
                    return new ProtectedAccountView({
                        curation: curation,
                        handle: handles.join(', ')
                    });
                }
            }
        };
    };

    // If we have not selected a presence, and there are no presences to
    // configure then we have nothing to show
    filters.noInsightsPresences = function (viewParams) {
        return function (curation) {
            if (isWithoutInsights(curation)) {
                const NoInsightsView = Marionette.ItemView.extend(viewParams);
                return new NoInsightsView();
            }
        };
    };

    //  Redirect if we have no valid tokens for displaying this presence
    filters.checkAccountAccess = function (source, templateOverride) {
        return function (curation) {
            if (!curation.presence) {
                return;
            }

            if (!_.get(curation.presence.get('sources'), [source, 'validToken'])) {
                curation.setProps('channelRedacted', true, {
                    silent: true
                });
                return new RivalIQ.channels.views.ChannelWall({
                    source: source,
                    template: templateOverride,
                    size: 'large'
                });
            }
            curation.setProps('channelRedacted', null, {
                silent: true
            });
        };
    };

    const shouldPollDefault = function (source, curation) {
        // poll if the focus presence is still loading
        if (!curation.presence) {
            return;
        }
        return curation.presence.get('isLoading');
    };

    const sourceInsightsLoadingBehaviors = {};
    sourceInsightsLoadingBehaviors[RivalIQ.enums.sources.LINKEDIN] = {
        api: function (curation) {
            return curation.presences.fetch();
        },
        condition: function (curation) {
            const presence = curation.presences.get(curation.getProp('presenceId'));
            return presence && presence.get('fetched_initial_history');
        },
        getTemplateConfiguration: function () {
            return {
                template: '#widgetLinkedInInsightsLoadingTemplate'
            };
        }
    };

    sourceInsightsLoadingBehaviors[RivalIQ.enums.sources.TWITTER_INSIGHTS] = {
        condition: function (curation, presences) {
            const presenceQuery = {};
            const channel = RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.TWITTER_INSIGHTS].channel;
            presenceQuery[`${channel}_presence_id`] = curation.getProp('presenceId');

            const companyPresence = _.find(presences, presenceQuery);
            if (!companyPresence) {
                return false;
            }

            return _.get(companyPresence, 'fetched_history');
        },
        getTemplateConfiguration: function () {
            return {
                template: '#widgetTwitterInsightsLoadingTemplate'
            };
        }
    };

    sourceInsightsLoadingBehaviors[RivalIQ.enums.sources.INSTAGRAM_INSIGHTS] = {
        condition: function (curation, presences) {
            const presenceQuery = {};
            const channel = RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.INSTAGRAM_INSIGHTS].channel;
            presenceQuery[`${channel}_presence_id`] = curation.getProp('presenceId');

            const companyPresence = _.find(presences, presenceQuery);
            if (!companyPresence) {
                return false;
            }

            return _.get(companyPresence, 'fetched_initial_history');
        },
        getTemplateConfiguration: function () {
            return {
                className: 'instagram-insights-loading',
                template: '#widgetInstagramInsightsLoadingTemplate'
            };
        }
    };

    // Poll if all presences are still loading
    filters.insightsLoading = function (source) {
        return function (curation) {
            const shouldPollFn = _.get(sourceInsightsLoadingBehaviors, [source, 'shouldPoll'], _.partial(shouldPollDefault, source));
            if (!shouldPollFn(curation)) {
                return null;
            }

            filters._startLoadingPoll(source, curation);

            const getTemplateConfiguration = _.get(sourceInsightsLoadingBehaviors, [source, 'getTemplateConfiguration'], _.noop);

            const config = _.extend({
                className: 'widget-insights-loading',
                template: '#widgetInsightsLoadingTemplate'
            }, getTemplateConfiguration(curation));

            const View = Marionette.ItemView.extend(config);

            // We want the toolbar title as well as the loadings screen
            RivalIQ.apps.Dashboard.curations.filters.updateShell(curation);
            return new View();
        };
    };

    filters._startLoadingPoll = function (source, curation) {
        const channel = RivalIQ.enums.sourceDetails[source].channel;

        const api = _.get(sourceInsightsLoadingBehaviors, [source, 'api'], function () {
            return $.getJSON(`/api/insights/${channel}/presences`);
        });

        const condition = _.get(sourceInsightsLoadingBehaviors, [source, 'condition'], function (curation, presences) {
            const presenceQuery = {};
            presenceQuery[`${channel}_presence_id`] = curation.getProp('presenceId');
            const companyPresence = _.find(presences, presenceQuery);
            return companyPresence && _.get(companyPresence, 'fetched_initial_history');
        });

        const options = {
            pollingDelay: 5000,
            pollingMaxAttempts: 120
        };

        RivalIQ.utils.polling.pollUntilCondition(_.partial(api, curation), _.partial(condition, curation), options)
            .done(function () {
                // TODO: nope. call refresh on curation.router
                curation.setProps({
                    'newToken': true
                });
                window.location.reload();
            });
    };

    filters.loadInsightsPostCurationProperties = function (curation) {
        const props = curation.getProps();
        const definitions = new RivalIQ.collections.MetricDefinitions([
            {
                concept: RivalIQ.metrics.id.FACEBOOK_INSIGHTS_POST_ENGAGEMENT_TOTAL,
                companyId: props.companyId,
                channel: props.channel,
                postId: props.postId
            },
            {
                concept: RivalIQ.metrics.id.FACEBOOK_INSIGHTS_POST_DETAILS,
                companyId: props.companyId,
                channel: props.channel,
                postId: props.postId,
                property: 'type'
            },
            {
                concept: RivalIQ.metrics.id.FACEBOOK_INSIGHTS_POST_DETAILS,
                companyId: props.companyId,
                channel: props.channel,
                postId: props.postId,
                property: 'boosted_post_total_spend'
            },
            {
                concept: RivalIQ.metrics.id.FACEBOOK_INSIGHTS_POST_DETAILS,
                companyId: props.companyId,
                channel: props.channel,
                postId: props.postId,
                property: 'was_boosted'
            }
        ]);

        const attributes = _.defaults(
            _.pick(props, ['landscapeId', 'objectType']),
            {
                objectType: 'post'
            }
        );

        return definitions.fetch(attributes).then(function (metrics) {
            const isUnderReporting = metrics.at(0);
            const postType = metrics.at(1);
            const boostedPostTotalSpend = metrics.at(2);
            const wasBoosted = metrics.at(3);

            curation.isFacebookUnderReporting = isUnderReporting.isFacebookUnderReporting();

            curation.postType = postType.getValue({
                format: false
            });
            // call it a native video if it is of type video and we have basic view data.
            curation.isFbVideo = (curation.postType === 'video' &&
                Boolean(_.get(postType, ['data', 'facebook_insights_data', 'post_video_views'])));

            const boostedSpend = parseFloat(_.get(boostedPostTotalSpend.getValue({
                format: false
            }), 'value'));
            curation.hasBoostedSpend = _.isFinite(boostedSpend);

            curation.wasBoosted = wasBoosted.getValue({
                format: false
            });
        });
    };

    // NOTE we can map a curation to a path if one was specified without a
    // `companyId`
    const INSTAGRAM_INSIGHTS_PATH_MAP = {};
    INSTAGRAM_INSIGHTS_PATH_MAP[RivalIQ.enums.curation.INSTAGRAM_INSIGHTS_POSTS] = 'posts';
    INSTAGRAM_INSIGHTS_PATH_MAP[RivalIQ.enums.curation.INSTAGRAM_INSIGHTS_STORIES] = 'stories';

    filters._instagramProcessMetadata = function (curation, metadata) {
        const path = 'insights/instagram';

        const presences = _(metadata.companies)
            .filter(function (company) {
                return _.get(company, ['sources', RivalIQ.enums.sources.INSTAGRAM_INSIGHTS, 'validToken'], false);
            })
            .map(function (company) {
                return _.extend({}, company, {
                    id: company.presenceId,
                    companyId: company.id,
                    isLoading: !_.get(company, ['sources', RivalIQ.enums.sources.INSTAGRAM_INSIGHTS, 'fetched'], true),
                    insufficientPermissions: _.get(company, ['sources', RivalIQ.enums.sources.INSTAGRAM_INSIGHTS, 'insufficientPermissions'], false)
                });
            })
            .value();

        curation.sources = metadata.sources;
        curation.facebookAdAccounts = metadata.facebookAdAccounts;
        curation.presences = new Backbone.Collection(presences);
        curation.unassociatedPresences = new Backbone.Collection();

        if (curation.presences.length) {
            curation.presence = curation.presences.find(function (presence) {
                return presence.get('companyId') === curation.getProp('companyId') &&
                    _.get(presence.get('sources'), [RivalIQ.enums.sources.INSTAGRAM_INSIGHTS, 'validToken']);
            });

            if (!curation.presence) {
                // no selected presence; let's try to default to the last one the user had selected.
                const companyId = _.get(RivalIQ.state.user.get('lastSelectedInstagramCompanies'), curation.getProp('landscapeId'));
                if (companyId) {
                    const presence = curation.presences.findWhere({
                        companyId: companyId
                    });
                    if (presence) {
                        return `${path}/${companyId}`;
                    }
                }

                const pick = curation.presences.find(function (presence) {
                    return _.get(presence.get('sources'), [RivalIQ.enums.sources.INSTAGRAM_INSIGHTS, 'validToken']);
                });

                if (pick) {
                    return _.compact([
                        path,
                        pick.get('companyId'),
                        _.get(INSTAGRAM_INSIGHTS_PATH_MAP, [curation.id])
                    ]).join('/');
                }
            }
        }

        if (curation.presence) {
            curation.setProps({
                presenceId: curation.presence.get('id'),
                insightsBlocked: curation.presence.get('isLoading')
            }, {
                silent: true,
                navigate: false
            });

            const instagramSource = _.get(curation.presence.get('sources'), [
                RivalIQ.enums.sources.INSTAGRAM_INSIGHTS
            ]);

            const presenceHandle = _.get(instagramSource, ['handle']);
            const oauthTokenId = _.get(instagramSource, ['_tokens', 0, 'id']);

            curation.activeFacebookAdAccounts = _.reduce(curation.facebookAdAccounts, function (memo, facebookAdAccount) {
                const isOwnedToken = (_.get(facebookAdAccount, ['oauth_token_id']) === oauthTokenId);
                const hasPromotePage = _.some(facebookAdAccount.promote_pages, function (promotePage) {
                    return (_.get(promotePage, ['instagram_business_account', 'username']) === presenceHandle);
                });
                return (isOwnedToken && hasPromotePage ? memo.concat(facebookAdAccount) : memo);
            }, []);
        }

        if (!curation.presence && curation.getProp('companyId')) {
            return path;
        }
    };

    filters.instagramPresenceLoader = function (curation) {
        const props = curation.getProps();

        if (props.clickedRefreshButtonInEmail) {

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ClickedRefreshInstagramInsightsExpiredConnection);

            // get the names of the instagram pages this account has access to now
            $.get('/api/account/facebook/tokensAccess')
                .then(function (results) {

                    const pages = results[RivalIQ.enums.sources.INSTAGRAM_INSIGHTS] || {};
                    const pageNames = _(pages)
                        .values()
                        .sortBy('name')
                        .map('name')
                        .value();

                    const pagesList = $.tagHtml('ul', {
                        html: _.map(pageNames, function (name) {
                            return $.tagHtml('li', {
                                text: name
                            });
                        }).join(' ')
                    });

                    const alertMessage = `We refreshed the connection to your Instagram pages. Currently accessible pages for your account: ${pagesList}`;

                    RivalIQ.execute('alert:info', alertMessage);
                });

        }

        return RivalIQ.data.privateMetadata.fetch(props, {
            force: true
        }).then(function (metadata) {
            return filters._instagramProcessMetadata(curation, metadata);
        });
    };

    filters.getInstagramInsightsBoostedPostsStatus = function (curation) {
        const props = curation.getProps();

        return RivalIQ.data.privateMetadata.fetch(props)
            .then(function (privateMetadata) {
                curation.hasAnyBoostedPosts = Boolean(_.get(privateMetadata.instagramPresences, [props.presenceId, 'last_boosted_post_found_at']));
            });
    };

    filters.noInstagramInsightsPresences = function (curation) {
        if (isWithoutInsights(curation)) {

            const hasSomePresenceAccess = _.some(_.get(curation.sources, [RivalIQ.enums.sources.INSTAGRAM_INSIGHTS, '_tokens']), function (token) {
                return Boolean(token.presence_id);
            });

            let errorMessage;

            if (hasSomePresenceAccess) {
                // The user doesn't have access to any presences in this landscape, but do have access to some presence.
                errorMessage = `You don't have access to Instagram Insights analytics for any company in this landscape.`;
            } else {
                // The user doesn't have access to any presence we know about, let's call out to fb to see what they can see.
                errorMessage = `You don't have access to Instagram Insights analytics for the Facebook pages you manage.`;
            }

            return new App.views.NoInstagramPresencesWithInsightsView({
                dashboardModel: curation,
                errorMessage: errorMessage
            });
        }
    };

    filters.noFacebookInsightsPresences = function (curation) {
        if (isWithoutInsights(curation)) {
            return new App.views.NoFacebookPresencesWithInsightsView({
                dashboardModel: curation
            });
        }
    };

    filters.checkAccountAccessInstagram = function (source, templateOverride) {
        return function (curation) {
            if (!curation.presence) {
                return;
            }

            if (!_.get(curation.presence.get('sources'), [source, 'validToken'])) {

                // if we're here, then the user has likely lost access to a presence.

                curation.setProps('channelRedacted', true, {
                    silent: true
                });
                return new RivalIQ.channels.views.ChannelWall({
                    source: source,
                    template: templateOverride,
                    size: 'large'
                });
            } else if (_.get(curation.presence.get('sources'), [source, 'insufficientPermissions'])) {
                curation.setProps('insightsBlocked', true, {
                    silent: true
                });
                const config = {
                    className: 'user-action-prompt widget-insights-nothing',
                    template: '#widgetInsufficientPermissionsTemplate',
                    serializeData: function () {
                        return {
                            presenceHandle: curation.presence.get('sources')[RivalIQ.enums.sources.INSTAGRAM_INSIGHTS].handle
                        };
                    }
                };

                const View = Marionette.ItemView.extend(config);

                // HACK update the shell so we can use the presence picker dropdown still
                RivalIQ.apps.Dashboard.curations.filters.updateShell(curation);
                return new View();
            }

            curation.setProps('channelRedacted', null, {
                silent: true
            });
        };
    };

    filters.checkAccountAccessTwitter = function (source, templateOverride) {
        return function (curation) {
            if (!curation.presence) {
                return;
            }

            if (!_.get(curation.presence.get('sources'), [source, 'validToken'])) {

                // if we're here, then the user has likely lost access to a presence.

                curation.setProps('channelRedacted', true, {
                    silent: true
                });
                return new RivalIQ.channels.views.ChannelWall({
                    source: source,
                    template: templateOverride,
                    size: 'large'
                });
            }
            curation.setProps('channelRedacted', null, {
                silent: true
            });
        };
    };
});
